const assertNever = (_) => {
  throw new Error();
};
export {
  assertNever
};
//# sourceMappingURL=assertNever.js.map
